import axiosService from 'services/axios.service';

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const startJob = async (payload: any): Promise<any> => {
    try {
        const response = await axiosService.post(`${BASE_API_URL}/job`, payload);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const getJobs = async (): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/job`);
    return response?.data;
};

export const getJobById = async (id: string): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/job/${id}`);
    return response?.data;
};

export const getCheckInfoTrack = async (payload: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/job/info-track`, payload);
    return response?.data;
};
